import { toHoursAndMinutes } from "../../scripts/_toHoursAndMinutes";
export function setupCourseHero() {
  let isCurriculumPage = document.querySelector('.sj-page-curriculum') || document.querySelector('.sj-page-detail-course');
  let isPathPage = document.querySelector('.sj-page-detail-path') || document.querySelector('.sj-page-path');


  if ((isCurriculumPage || isPathPage) && !document.querySelector('.as-course-hero')) {
    let content = document.querySelector('#skilljar-content');
    let courseHero = document.createElement('div');
    courseHero.classList.add(...['as-course-hero', 'row-flow']);

    let courseTags = window.skilljarCourse && window.skilljarCourse.tags;
    let courseDifficulty = window.skilljarCourse && ((courseTags.includes('Advanced') && "Advanced") || (courseTags.includes('Intermediate') && "Intermediate") || (courseTags.includes('Beginner') && "Beginner") || "");
    let courseTime = document.querySelector(".sj-course-time") ? document.querySelector(".sj-course-time").innerHTML : "";
    let courseCost = document.querySelector(".storefront-price span") ? document.querySelector(".storefront-price span").innerText.trim() : (document.querySelector('.purchase-button-full-text') ? document.querySelector(".purchase-button-full-text").innerText.replace("Purchase | ", "").trim() : "Free");
    let courseStartButton = document.querySelector('.sj-summary .button.start-button');
    courseCost === "Register | Available" ? courseCost = "Free" : "";
    courseCost === "Start" ? courseCost = "Free" : "";
    let coursePurchaseButton = document.querySelector('.button.purchase-button');
    coursePurchaseButton ? coursePurchaseButton.innerHTML = coursePurchaseButton.innerHTML.replace(' | Available', '') : '';
    let courseResumeButton = document.querySelector('.button.resume-button');
    let lessonsCompletedText = document.querySelector('.sj-text-x-of-y-lessons-completed span');
    let numberCourses = document.querySelectorAll('.lesson-row') ? document.querySelectorAll('.lesson-row').length : "9";
    let signInLink = document.querySelector('.login-link.sj-text-sign-in');
    let courseCompletionDate = window.skilljarCourseProgress && window.skilljarCourseProgress.completed_at !== "" && new Date(window.skilljarCourseProgress.completed_at);
    let courseCount;
    let numCoursesComplete = 0;
    let pathCompleted = false;

    courseCompletionDate && courseStartButton ? courseStartButton.innerText = 'Take Again' : ""

    /** Get Certification Take Again Button */
    const takeAgainButton = document.querySelector('form[action*=reenroll]') ? document.querySelector('form[action*=reenroll]') : null;
    if (takeAgainButton) {
      takeAgainButton.addEventListener("submit", (event) => {
        event.preventDefault();
      })
    }

    let courseboxes = document.querySelectorAll('a.coursebox-container.course:not(.search-only)');

    if (isPathPage) {
      /** Get total path time by adding together all course times */
      let courseTimes = document.querySelectorAll('.as-coursebox__meta-time');
      let totalPathTime = 0;
      courseTimes.forEach((course) => {
        let time = course.innerText.replace("0 hr", "").replace(" min", "").trim();
        totalPathTime += Number(time);
      });
      courseTime = toHoursAndMinutes(totalPathTime);

      /** Get number of modules in path */
      courseCount = window.skilljarPath ? window.skilljarPath.pathItems.length : "";

      /** Get Courseboxes to build path status banner */
      courseboxes.forEach((course) => {
        course.getAttribute('data-course-status') == 'complete' && numCoursesComplete++;
      });

      if (courseCount === numCoursesComplete) {
        pathCompleted = true;
      }
    }

    function setupProgressBar() {
      let courseboxes = document.querySelectorAll('a.coursebox-container.course:not(.search-only)');
      let notches = ``;
      courseboxes.forEach((course, i) => {
        notches += `<div class="as-progress-bar__notch ${i < numCoursesComplete ? 'as-progress-bar__notch--completed' : ""}"></div>`
      })
      return `${notches}`
    }

    courseHero.innerHTML = `
    <div class="as-course-hero__title-wrapper row-flow">
      <h1 class="as-course-hero__title">${(window.skilljarCourse && window.skilljarCourse.title) || (window.skilljarPath && `${window.skilljarPath.title} Learning Path`)}</h1>
      <p class="as-course-hero__description">${(window.skilljarCourse && window.skilljarCourse.short_description || window.skilljarPath && window.skilljarPath.short_description)}</p>
    </div>
    <div class="as-course-hero__meta">
      ${courseCount ? `
      <div class="as-course-hero__course-count">
        <img src="https://astronomer.github.io/academy-theme/dist/icons/list-dashes.svg" width="32" height="32 alt="" />
        <span>${courseCount} modules</span>
      </div>
      ` : ""}

      ${courseTime ? `
      <div class="as-course-hero__course-time">
        <img src="https://astronomer.github.io/academy-theme/dist/icons/clock.svg" width="32" height="32 alt="" />
        <span>${courseTime}</span>
      </div>
      ` : ""}
      ${courseDifficulty ? `
      <div class="as-course-hero__course-difficulty">
        <p>Difficulty Level: <span class="as-difficulty-tag as-tag">${courseDifficulty}</span></p>
      </div>
      ` : ""}
      ${courseCost ? `
      <div class="as-course-hero__course-cost">
        <p>Cost: <span class="as-cost-tag as-tag as-tag-filled">${courseCost}</span></p>
      </div>
      ` : ""}
    </div>

    ${isCurriculumPage ? `
      <div class="as-banner ${courseCompletionDate ? "as-banner--complete" : ""}">
        <div class="as-course-hero__module-button-wrapper">
          ${(courseStartButton && !courseCompletionDate) ? courseStartButton.outerHTML : (coursePurchaseButton ? coursePurchaseButton.outerHTML : '')}
          ${(courseResumeButton && !courseCompletionDate) ? courseResumeButton.outerHTML : ''}
          ${courseCompletionDate ? `<img src="https://astronomer.github.io/academy-theme/dist/icons/check-circle-green.svg" width="48" height="48" alt="" />` : ''}
        </div >
        <div class="as-course-hero__module-progress">
          ${coursePurchaseButton && !window.skilljarUser && signInLink !== null ? `Already Registered? ${signInLink && signInLink.outerHTML}` : ''}
          ${(courseStartButton && !courseResumeButton && !courseCompletionDate) ? `${numberCourses} lessons in this module.` : ''}
          ${(lessonsCompletedText && !courseCompletionDate && courseResumeButton) ? `${lessonsCompletedText.innerText.replace(/(\([\d]*\%\))/gmi, "")} <img src="https://astronomer.github.io/academy-theme/dist/icons/pie2.svg" width="48" height="48" alt="" />` : ''}
          ${courseCompletionDate ? `You completed this course on ${courseCompletionDate.toLocaleDateString("en-us", { year: "numeric", month: "long", day: "numeric", })}` : ""}
          ${courseCompletionDate && courseStartButton ? courseStartButton.outerHTML : ""}
          ${courseCompletionDate && takeAgainButton ? takeAgainButton.outerHTML : ""}
        </div >
      </div >
      ` : ""}

    ${isPathPage ? `
    <div class="as-banner ${courseCompletionDate || pathCompleted ? "as-banner--complete" : ""} ${(!pathCompleted && window.skilljarUser) ? 'as-banner--in-progress' : ''}">
      ${courseCompletionDate || pathCompleted ? `
        <div class="as-flex-container">
          <img src="https://astronomer.github.io/academy-theme/dist/icons/shooting-star.svg" width="48" height="48" alt="" /> 
          <p>Congratulations! You completed this Learning Path!</p>
        </div>
      ` : ""
        }

      ${(!pathCompleted && window.skilljarUser) ? `
        <p>
          You've completed ${numCoursesComplete} of ${courseCount} modules in this Learning Path.
        </p>
        <div class="as-progress-bar">
          ${setupProgressBar()}
        </div>
      ` : ""
        }


      <div class="as-course-hero__module-button-wrapper">
        ${(courseStartButton && !courseCompletionDate && window.skilljarUser) ? courseStartButton.outerHTML : (coursePurchaseButton && !window.skilljarUser && numCoursesComplete === 0 ? coursePurchaseButton.outerHTML : '')}
        ${courseCompletionDate ? `<img src="https://astronomer.github.io/academy-theme/dist/icons/check-circle-green.svg" width="48" height="48" alt="" />` : ''}
      </div>
      <div class="as-course-hero__module-progress">
        ${coursePurchaseButton && !window.skilljarUser && signInLink !== null ? `Already Registered? ${signInLink && signInLink.outerHTML}` : ''}
      </div>
    </div >
      ` : ""}
  `;

    content && content.prepend(courseHero);
  }
}